export const InvoicePdfLinksRoute = {
  InvoicePdfLink: (orderId: number): string => `/invoice/downloads/${orderId}`,
};
